import { performHttpFetch } from '@atlassian/conversation-assistant-utils/httpUtils';

import { SPACES_API_PATH } from '../../common/constants';
import type { CreateSpaceResponse } from '../../controllers/space-store/types';
import type { SpaceSource } from '../../ui/create-space-modal/types';

export type CreateSpaceRequest = {
	name: string;
	description?: string;
	instructions?: string;
	sources?: SpaceSource[];
	emoji?: string;
};

export type CreateSpaceFetchParams = {
	request: CreateSpaceRequest;
	cloudId: string;
	product: string;
	experienceId: string;
};

export const createSpaceFetchAction = async ({
	request,
	cloudId,
	product,
	experienceId,
}: CreateSpaceFetchParams): Promise<CreateSpaceResponse> =>
	performHttpFetch({
		path: SPACES_API_PATH,
		options: {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'x-cloudid': cloudId,
				'x-product': product,
				'x-experience-id': experienceId,
			},
			credentials: 'include',
			body: JSON.stringify(request),
		},
	});
